import React, {Component} from 'react';
import {gpn} from "../GPN"
import Back from "../sections/Back";
import config from "../config";
import Icon from "../sections/MUI/Icon";
import axios from "axios";
import Field from "../sections/MUI/Field";
import Checks from "../sections/MUI/Checks";
import Button from "../sections/MUI/Button";
import {toast} from "react-toastify";
import Modal from "../sections/MUI/Modal";

const perArr = [
    "dashboard",
    "admin",
    "service",
    "category",
    "order",
    "expert",
    "region",
    "user",
    "payment",
    "chats"
]

class Admins extends Component {

    state = {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        permissions: [],

        boxAdd: false,
        admins: [],

        editIndex: -1
    };


    componentDidMount() {
        config.scrollTop();
        this.getAdmins();
    }

    getAdmins() {
        axios.get(`${config.api}/admin/admins?token=${config.token}`)
            .then(r => {
                this.setState({admins: r.data.result});
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    submit() {
        const {firstName, lastName, phoneNumber, permissions} = this.state;
        if (firstName !== "" && lastName !== "" && phoneNumber !== "") {
            let params = new URLSearchParams();
            params.append("firstName", firstName);
            params.append("lastName", lastName);
            params.append("phoneNumber", phoneNumber);
            params.append("permissions", JSON.stringify(permissions));
            toast.info("در حال ثبت ...");
            axios.post(`${config.api}/admin/admin?token=${config.token}`, params)
                .then(r => {
                    toast.success("با موفقیت ثبت شد");
                    this.getAdmins();
                })
                .catch(err => {
                    config.handleError(err);
                });
        } else {
            toast.error("همه فیلد ها را وارد کنید!")
        }

    }

    edit() {
        const {editIndex, admins} = this.state;

        const {id, firstName, lastName, phoneNumber, permissions} = admins[editIndex];

        if (firstName !== "" && lastName !== "" && phoneNumber !== "") {
            let params = new URLSearchParams();
            params.append("id", id);
            params.append("firstName", firstName);
            params.append("lastName", lastName);
            params.append("phoneNumber", phoneNumber);
            params.append("permissions", JSON.stringify(permissions));
            toast.info("در حال ویرایش ...")
            axios.put(`${config.api}/admin/admin?token=${config.token}`, params)
                .then(r => {
                    this.setState({editIndex: -1});
                    toast.success("با موفقیت ویرایش شد");
                    this.getAdmins();
                })
                .catch(err => {
                    config.handleError(err);
                });
        } else {
            toast.error("همه فیلد ها را وارد کنید")
        }
    }

    handleInputChange(name, value) {
        let {admins, editIndex} = this.state;
        admins[editIndex][name] = value;
        this.setState({
            admins
        });
    }

    delete(id) {
        toast.info("در حال حذف ...")
        axios.delete(`${config.api}/admin/admin?token=${config.token}&id=${id}`)
            .then(r => {
                toast.success("با موفقیت حذف شد");
                this.getAdmins();
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    render() {
        const {admins, firstName, lastName, phoneNumber, permissions, boxAdd, editIndex} = this.state;
        return (
            <div className="admins">
                {editIndex !== -1 ?
                    <Modal icon="edit"
                           onCloseClick={() => this.setState({editIndex: -1})}
                           display={editIndex !== -1}
                           title="ویرایش">
                        <div className="row">
                            <div className="col-md-4">
                                <Field
                                    label="نام"
                                    name="firstName"
                                    value={admins[editIndex].firstName}
                                    onChange={(name, value) => this.handleInputChange(name, value)}/>
                            </div>
                            <div className="col-md-4">
                                <Field
                                    label="نام خانوادگی"
                                    name="lastName"
                                    value={admins[editIndex].lastName}
                                    onChange={(name, value) => this.handleInputChange(name, value)}/>

                            </div>
                            <div className="col-md-4">
                                <Field
                                    label="شماره موبایل"
                                    name="phoneNumber"
                                    maxLength={13}
                                    value={admins[editIndex].phoneNumber}
                                    onChange={(name, value) => this.handleInputChange(name, value)}/>
                            </div>
                            <div className="col-md-6">
                                <Checks
                                    label="سطح دسترسی"
                                    value={admins[editIndex].permissions}
                                    onChange={(name, value) => this.handleInputChange(name, value)}
                                    name="permissions"
                                    options={perArr}/>
                            </div>
                            <div className="col-md-6">

                            </div>
                            <div className="col-md-5">
                                <Button icon="edit" submit={false}
                                        onClick={() => this.edit()}>ویرایش</Button>
                            </div>
                        </div>
                    </Modal>
                    : null
                }

                <Back {...this.props}/>
                <div className="new">
                    <div className="row">
                        <div className="col-md-4">
                            <Button submit={false} icon="plus" backgroundColor="#1565C0"
                                    onClick={() => this.setState({boxAdd: !boxAdd})}>ثبت کردن</Button>
                        </div>
                    </div>
                    {
                        boxAdd ?
                            <div className="row">
                                <div className="col-md-4">
                                    <Field name="firstName"
                                           label="نام"
                                           value={firstName}
                                           onChange={(name, value) => this.setState({[name]: value})}/>
                                </div>
                                <div className="col-md-4">
                                    <Field name="lastName"
                                           label="نام خانوادگی"
                                           value={lastName}
                                           onChange={(name, value) => this.setState({[name]: value})}/>
                                </div>
                                <div className="col-md-4">
                                    <Field name="phoneNumber"
                                           label="شماره موبایل"
                                           maxLength={13}
                                           value={phoneNumber}
                                           onChange={(name, value) => this.setState({[name]: value})}/>
                                </div>
                                <div className="col-md-6">
                                    <Checks
                                        label="سطح دسترسی"
                                        value={permissions}
                                        onChange={(name, value) => this.setState({[name]: value})}
                                        name="permissions"
                                        options={perArr}/>

                                    <Button submit={false} icon="plus" onClick={() => this.submit()}>ثبت مدیر</Button>
                                </div>
                            </div>
                            : null
                    }
                </div>

                <br/>
                <div className="list">
                    {admins.map((a, i) =>
                        <article key={"admin" + i}>
                            <div className="row">
                                <div className="col-auto">
                                    <p className="full-name"><span>{a.firstName}</span>&nbsp;
                                        <span>{a.lastName}&nbsp;{a.phoneNumber === this.props.phoneNumber ? "(شما)" : ""}</span>
                                    </p>
                                </div>
                                <div className="col">
                                    <div className="phone-number">{a.phoneNumber}</div>
                                </div>

                                <div className="col-auto">
                                    <Icon i="edit" className="edit-icon" onClick={() => this.setState({editIndex: i})}/>
                                    <Icon i="trash" className="delete-icon"
                                          onDoubleClick={() => this.delete(a.id)}/>
                                </div>
                            </div>
                        </article>
                    )}
                </div>
            </div>
        );
    }
}

export default gpn(Admins);